<template>
  <v-btn
    v-bind="activatorProps"
    :text="title"
    class="ma-1"
    variant="tonal"
    @click="isActive = true"
    >مطالبة الكل</v-btn
  >
  <v-dialog max-width="900" v-model="isActive">
    <v-card :title="title">
      <v-sheet class="mx-auto" width="300">
        <v-form @submit.prevent enctype="multipart/form-data" ref="form">
          <v-select
            v-model="formData.id"
            :items="items"
            label="القطاعات"
            item-title="name"
            item-text="code"
            item-value="id"
          ></v-select>
        </v-form>
      </v-sheet>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="حفظ" @click="save"></v-btn>

        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { api } from "@/plugins/api";
export default {
  props: ["saveFunction", "item", "iconName"],
  data() {
    return {
      isActive: false,

      formData: {
        id: -1,
      },
      items: [],
    };
  },
  methods: {
    async fetchItems() {
      try {
        const response = await api.get("/meters_parents");
        this.items = response.data.data;
      } catch (err) {
        this.error = "Failed to load items: " + err.message;
      } finally {
        this.loading = false;
      }
    },
    async validate() {
      const { valid } = await this.$refs.form.validate();

      if (valid) alert("Form is valid");
    },
    reset() {
      this.$refs.form.reset();
    },
    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        this.saveFunction(this.formData.id);

        this.isActive = false;
      }
    },
    close() {
      this.isActive = false;
    },
  },
  computed: {
    title() {
      return "مطالبة الكل";
    },
  },
  async mounted() {
    await this.fetchItems();
  },
};
</script>
